import { API_URL, METHOD } from '../constants/network'
import { serialize } from '../utils'
import { fetchAPI } from '../utils/network'

export const getReadingBooks = (params) => {
    return fetchAPI({
        url: `${API_URL.READING_BOOKS}${serialize(params)}`,
        method: METHOD.GET,
    })
}

export const createReadingBook = (body) => {
    return fetchAPI({
        url: API_URL.READING_BOOKS,
        method: METHOD.POST,
        body,
    })
}

export const updateReadingBook = (id, body) => {
    return fetchAPI({
        url: `${API_URL.READING_BOOKS}/${id}`,
        method: METHOD.PUT,
        body,
    })
}

export const bulkUploadReadingBooks = (books) => {
    return fetchAPI({
        url: API_URL.READING_BOOKS_BULK,
        method: METHOD.POST,
        body: { books },
    })
}

export const bulkDeleteReadingBooks = (ids) => {
    return fetchAPI({
        url: API_URL.READING_BOOKS_BULK_DELETE,
        method: METHOD.POST,
        body: { ids },
    })
}

